import { ProfileFormField } from '../components/ProfileFormField';
import EntityFormProvider from '../EntityFormProvider';

export default function Health() {
  return (
    <EntityFormProvider title="Health">
      <ProfileFormField entityType="Health" fieldName="status" label="Overall health status" />
      <ProfileFormField entityType="Health" fieldName="is_smoker" label="Are you a smoker?" />
      <ProfileFormField entityType="Health" fieldName="has_addictions" label="Addictions" />
      <ProfileFormField
        entityType="Health"
        fieldName="addiction_info"
        label="More information (if applicable)"
      />
      <ProfileFormField
        entityType="Health"
        fieldName="partakes_in_hazardous_pursuits"
        label="Do you partake in any hazardous pursuits?"
      />
      <ProfileFormField
        entityType="Health"
        fieldName="hazardous_pursuits_info"
        label="More information (if applicable)"
      />
      <ProfileFormField
        entityType="Health"
        fieldName="has_physical_disabilities"
        label="Physical disability"
      />
      <ProfileFormField
        entityType="Health"
        fieldName="physical_disabilities_info"
        label="More information (if applicable)"
      />
      <ProfileFormField
        entityType="Health"
        fieldName="has_mental_health_problems"
        label="Any mental health problems?"
      />
      <ProfileFormField
        entityType="Health"
        fieldName="mental_health_problems_info"
        label="More information (if applicable)"
      />
      <ProfileFormField
        entityType="Health"
        fieldName="has_history_of_chronic_family_illness"
        label="History of chronic family illness"
      />
      <ProfileFormField
        entityType="Health"
        fieldName="chronic_family_illness_info"
        label="More information (if applicable)"
      />
    </EntityFormProvider>
  );
}
